import api from "../api/axios";

export const approveEmployeeAbsence = async (approverId, absenceId, data) => {
  const { allow_leave, allow_attendance_approval } = data;
  try {
    const response = await api.post(
      `employee-absences/approve/${approverId}/${absenceId}`,
      { allow_leave, allow_attendance_approval }
    );

    if (response.data.success != true) {
      throw new Error("Failed to approve absence");
    }

    return response.data;
  } catch (error) {
    console.error("Error approving absence:", error);
    throw error;
  }
};

export const rejectEmployeeAbsence = async (approverId, absenceId, reason) => {
  try {
    const response = await api.post(
      `employee-absences/reject/${approverId}/${absenceId}`,
      { rejection_reason: reason }
    );

    if (response.data.success != true) {
      throw new Error("Failed to reject absence");
    }

    return response.data;
  } catch (error) {
    console.error("Error rejecting absence:", error);
    throw error;
  }
};
